import { Avatar, ButtonBase, Stack, styled, Typography } from '@mui/material';
import type { StyledAvatarProps } from './types';
import { NEW_COLORS } from '../../../../themes/colors/newColors';

const DrawerHeaderContainer = styled(Stack)`
  padding-bottom: 20px;
  flex-direction: row;
  align-items: center;
`;

const IconButton = styled(ButtonBase)`
  justify-content: flex-start;
`;

const StyledStack = styled(Stack)`
  cursor: pointer;
`;

const DrawerToggleButton = styled(Stack)`
  align-items: center;
  justify-content: center;
  width: 100%;
`;

const Username = styled(Typography)(() => ({
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  maxWidth: '40ch',
}));

const StyledAvatar = styled(Avatar, {
  shouldForwardProp: styledAvatarProps =>
    styledAvatarProps !== 'isBackofficeMobile',
})<StyledAvatarProps>(({ isBackofficeMobile }) => ({
  backgroundColor: isBackofficeMobile
    ? NEW_COLORS.GRAYSCALE[600]
    : NEW_COLORS.GRAYSCALE[100],
  color: isBackofficeMobile ? NEW_COLORS.BASE.WHITE : NEW_COLORS.GRAYSCALE[700],
}));

export {
  Username,
  StyledStack,
  IconButton,
  DrawerHeaderContainer,
  StyledAvatar,
  DrawerToggleButton,
};
